module.exports = __webpack_public_path__ + "static/media/lineto-brown-bold-c.599a0123.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lineto-brown-bold-c.eot
// module id = 69
// module chunks = 0